var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{tag:"component",attrs:{"title":_vm.title,"icon":_vm.icon,"name":_vm.name,"options":_vm.options,"value":_vm.value},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }